import script from "./CustomerAiPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerAiPlan.vue?vue&type=script&setup=true&lang=js"

import "./CustomerAiPlan.vue?vue&type=style&index=0&id=caead0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caead0bc"]])

export default __exports__